import nprogress from 'nprogress'
import { ElMessage, ElMessageBox } from 'element-plus'
import { MessageType } from 'element-plus/es/components/message/src/message'

/**
 * 表单/接口错误提示：若 request 拦截器已提示过（_messageShown），则不再重复提示
 */
export function showErrorIfNeeded(error: any, fallback = '操作失败') {
  if (!error?._messageShown) {
    ElMessage.error(error?.message || fallback)
  }
}

// 消息提示
export function showMessage(message = '提示内容', type: MessageType = 'success', customClass = '') {
  return ElMessage({
    type: type,
    message,
    customClass
  })
}

// 弹出确认框
export function showModel(content = '提示内容', type: MessageType = 'warning', title = '') {
  return ElMessageBox.confirm(content, title, {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type
  })
}

// 显示页面加载 Loading
export function showPageLoading() {
  nprogress.start()
}

// 隐藏页面加载 Loading
export function hidePageLoading() {
  nprogress.done()
}
